export const getEpgPathFromSignInModal = (query: URLSearchParams) => {
  const params = new URLSearchParams()

  const category = query.get('category')
  const date = query.get('date')

  if (category) params.set('category', category)
  if (date) params.set('date', date)

  return `/epg?${params}`
}
